import { Box, Divider, Text } from '@wix/design-system';
import React from 'react';
export const InputCharCounter = _ref => {
  let {
    count,
    min = 0,
    max,
    maxDisplayOffset = 10,
    showDivider = false
  } = _ref;
  const showCounter = count >= min;
  const showMax = max && count < max - maxDisplayOffset;
  const maxExceeded = max && count > max;
  return showCounter ? /*#__PURE__*/React.createElement(Box, {
    gap: "SP1",
    maxHeight: "18px",
    verticalAlign: "middle"
  }, showDivider && /*#__PURE__*/React.createElement(Box, {
    height: "12px"
  }, /*#__PURE__*/React.createElement(Divider, {
    direction: "vertical"
  })), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    skin: maxExceeded ? 'error' : 'standard',
    light: true,
    secondary: true
  }, showMax ? String(count) : `${count}/${max}`)) : null;
};
//# sourceMappingURL=input-char-counter.js.map